import { render, staticRenderFns } from "./PriceManipulationsModal.vue?vue&type=template&id=286cff35&scoped=true"
import script from "./PriceManipulationsModal.vue?vue&type=script&lang=ts"
export * from "./PriceManipulationsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286cff35",
  null
  
)

export default component.exports